export default __webpack_public_path__ + "static/media/openness2Img4.e856b22e.png";